import { h } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { FONT_FALLBACKS } from '../../../fonts';
import { useNewStore, usePlayerContext, useStyles } from '../../../common/hooks';
import '../../theme/styles/subtitles.css';
import { subtitlePositionAndSize } from '../../utils/tools';
import { SUBTITLE_CONTAINER_STYLE, SUBTITLE_LINE_STYLE } from './styles';

function SubtitleContainer({
  width,
  height,
  show,
  style = {},
  sideMargin = 0
}) {
  const player = usePlayerContext();
  const subtitlesState = useNewStore('subtitles', player);
  const { isTv } = useNewStore('media', player);
  const { UIVisible, isPortrait } = useNewStore('ui', player);

  const { tags, active, alignment, position, settings: { fontFamily, fontRatio = 1 } } = subtitlesState;

  const tagStyles = useMemo(
    () => ({
      ...SUBTITLE_LINE_STYLE,
      fontFamily: `${fontFamily}, ${FONT_FALLBACKS}`,
      fontSize: `${1 * fontRatio}em`
    }),
    [fontRatio, fontFamily]
  );

  const tvTop = useMemo(
    () => (isTv
      ? {
        default: { top: 48 },
        'extraLargeTv+extraLarge': { top: 63 }
      }
      : {
        default: { top: isPortrait ? 85 : 75 },
        extraSmall: { top: isPortrait ? 83 : 45 },
        small: { top: isPortrait ? 84 : 55 },
        medium: { top: isPortrait ? 90 : 69 },
        extraLarge: { top: 83 }
      }),
    [isTv, isPortrait]
  );
  const { top } = useStyles()(tvTop);

  const [transition, setTransition] = useState('none');
  useEffect(() => {
    const transitionDelay = 200;
    if (UIVisible) {
      setTransition(UIVisible ? `all cubic-bezier(0.16, 1, 0.99, 0.99) ${transitionDelay / 1000}s` : '');
    } else {
      setTimeout(() => setTransition('none'), transitionDelay);
    }
  }, [UIVisible]);

  const wrapperStyle = useMemo(
    () => {
      const getParams = (() => {
        if (!UIVisible) {
          return { width, height, position, alignment, fontRatio };
        }

        return {
          position: {
            top,
            left: 50
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          },
          fontRatio,
          width,
          height
        };
      });
      return ({
        ...SUBTITLE_CONTAINER_STYLE,
        ...subtitlePositionAndSize(getParams(), sideMargin),
        transition
      });
    },
    [width, height, alignment, position, fontRatio, sideMargin, UIVisible, top, transition]
  );

  if (!show || !active || tags.length <= 0) return null;

  return (
    <div style={style} className="ftv-magneto--wrapper-subtitles">
      <div
        className="ftv-magneto--subtitles"
        style={wrapperStyle}
      >
        {tags.map(({ tagName, text, cssClasses }) => {
          const Tag = tagName;
          return !!text && <Tag className={cssClasses?.join(' ') || ''} style={tagStyles}>{text}</Tag>;
        })}
      </div>
    </div>
  );
}

export default SubtitleContainer;
